// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Paper,
//   Chip,
//   CircularProgress,
//   Alert,
//   Divider,
//   Grid,
//   Button,
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// const AssessmentResults = () => {
//   const { assignmentId } = useParams();
//   const navigate = useNavigate();
//   const { store_id, user_id } = useATS();
//   const [results, setResults] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchResults = async () => {
//       try {
//         const res = await axios.get(
//           `${API_BASE}/api/assessment/user-assessments/${assignmentId}/results`,
//           {
//             params: { store_id, user_id },
//           },
//         );
//         setResults(res.data.data);
//       } catch (err) {
//         console.error(err);
//         setError(err.response?.data?.statusMessage || "Failed to load results");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchResults();
//   }, [assignmentId, store_id, user_id]);

//   if (loading)
//     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
//   if (error) return <Alert severity="error">{error}</Alert>;
//   if (!results) return null;

//   const passed = results.total_score >= results.passing_score;

//   return (
//     <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
//       <Paper sx={{ p: 3, mb: 3, borderRadius: 1.5, textAlign: "center" }}>
//         <Typography variant="h4" fontWeight={700}>
//           {results.assessment_title}
//         </Typography>
//         <Typography
//           variant="h6"
//           color={passed ? "success.main" : "error.main"}
//           sx={{ mt: 1 }}
//         >
//           {passed ? "PASSED" : "FAILED"} – Score: {results.total_score} /{" "}
//           {results.max_score}
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Submitted: {new Date(results.submitted_at).toLocaleString()}
//         </Typography>
//       </Paper>

//       <Typography variant="h5" fontWeight={600} gutterBottom>
//         Your Answers
//       </Typography>
//       {results.answers.map((ans, idx) => {
//         const userSelected =
//           ans.selected_option !== undefined
//             ? ans.options[ans.selected_option]
//             : "Not answered";
//         const correctAnswer = ans.options[ans.correct_option];
//         const isCorrect = ans.is_correct;

//         return (
//           <Paper
//             key={ans.question_id}
//             sx={{
//               p: 2,
//               mb: 2,
//               borderRadius: 1.5,
//               border: `1px solid ${isCorrect ? "#4caf50" : "#f44336"}20`,
//             }}
//           >
//             <Typography variant="subtitle1" fontWeight={600}>
//               Q{idx + 1}: {ans.question_text}
//             </Typography>
//             <Box sx={{ mt: 1, pl: 2 }}>
//               <Typography variant="body2">
//                 <strong>Your answer:</strong> {userSelected}
//                 {isCorrect ? (
//                   <CheckCircleIcon
//                     sx={{
//                       color: "success.main",
//                       fontSize: 16,
//                       ml: 1,
//                       verticalAlign: "middle",
//                     }}
//                   />
//                 ) : (
//                   <CancelIcon
//                     sx={{
//                       color: "error.main",
//                       fontSize: 16,
//                       ml: 1,
//                       verticalAlign: "middle",
//                     }}
//                   />
//                 )}
//               </Typography>
//               {!isCorrect && (
//                 <Typography variant="body2" color="text.secondary">
//                   <strong>Correct answer:</strong> {correctAnswer}
//                 </Typography>
//               )}
//               <Typography variant="caption" color="text.secondary">
//                 Points: {ans.points_earned} / {ans.max_score}
//               </Typography>
//             </Box>
//           </Paper>
//         );
//       })}

//       <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
//         <Button
//           variant="contained"
//           onClick={() => navigate("/ats/my-assessments")}
//         >
//           Back to My Assessments
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default AssessmentResults;
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Grid,
  Button,
  Chip,
  LinearProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useATS } from "../atsModule/context/ATSContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const TEAL = "#0c8a9b";
const FONT = "'DM Sans', 'Inter', sans-serif";

const KF_ID = "ar2-kf";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const s = document.createElement("style");
  s.id = KF_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  `;
  document.head.appendChild(s);
}

const AssessmentResults = () => {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const { store_id, user_id } = useATS();
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/assessment/user-assessments/${assignmentId}/results`,
          { params: { store_id, user_id } },
        );
        setResults(res.data.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.statusMessage || "Failed to load results");
      } finally {
        setLoading(false);
      }
    };
    fetchResults();
  }, [assignmentId, store_id, user_id]);

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress sx={{ color: TEAL }} />
      </Box>
    );
  if (error)
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        {error}
      </Alert>
    );
  if (!results) return null;

  const passed = results.total_score >= results.passing_score;
  const scorePercent = results.max_score
    ? Math.round((results.total_score / results.max_score) * 100)
    : 0;
  const correctCount = results.answers?.filter((a) => a.is_correct).length || 0;
  const totalCount = results.answers?.length || 0;

  return (
    <Box
      sx={{
        minHeight: "80vh",
        borderRadius: 0.4,
        background: "#f8f9fa",
        fontFamily: FONT,
        p: { xs: 2, sm: 3.5 },
      }}
    >
      {/* ── Back button ──────────────────────────────────────────────── */}
      <Button
        startIcon={<ArrowBackIcon sx={{ fontSize: "16px !important" }} />}
        onClick={() => navigate("/ats/my-assessments")}
        sx={{
          fontFamily: FONT,
          fontWeight: 500,
          fontSize: "0.85rem",
          color: "#868e96",
          textTransform: "none",
          px: 0,
          mb: 2.5,
          animation: "fadeUp .35s ease both",
          "&:hover": { background: "transparent", color: "#495057" },
        }}
      >
        Back to My Assessments
      </Button>

      {/* ── Score card ───────────────────────────────────────────────── */}
      <Paper
        sx={{
          borderRadius: "20px",
          p: 3.5,
          mb: 3,
          boxShadow: "0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04)",
          background: "#fff",
          animation: "fadeUp .4s ease both",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontFamily: FONT,
                fontWeight: 700,
                color: "#1a1d23",
                fontSize: "1.45rem",
                letterSpacing: "-0.3px",
                mb: 0.4,
              }}
            >
              {results.assessment_title}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontFamily: FONT, color: "#868e96" }}
            >
              Submitted:{" "}
              {new Date(results.submitted_at).toLocaleString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          </Box>
          <Chip
            label={passed ? "PASSED" : "FAILED"}
            sx={{
              fontFamily: FONT,
              fontWeight: 700,
              fontSize: "0.8rem",
              background: passed ? "#f0fdf4" : "#fff5f5",
              color: passed ? "#16a34a" : "#e03131",
              borderRadius: "8px",
              height: 30,
              letterSpacing: "0.05em",
            }}
          />
        </Box>

        {/* Stats row */}
        <Grid container spacing={2.5} sx={{ mt: 2.5 }}>
          {[
            {
              label: "Score",
              value: `${results.total_score} / ${results.max_score}`,
              icon: (
                <EmojiEventsOutlinedIcon sx={{ fontSize: 20, color: TEAL }} />
              ),
              bg: "#e6f6f8",
            },
            {
              label: "Accuracy",
              value: `${scorePercent}%`,
              icon: <CheckCircleIcon sx={{ fontSize: 20, color: "#16a34a" }} />,
              bg: "#f0fdf4",
            },
            {
              label: "Correct",
              value: `${correctCount} / ${totalCount}`,
              icon: <CheckCircleIcon sx={{ fontSize: 20, color: "#16a34a" }} />,
              bg: "#f0fdf4",
            },
          ].map((stat) => (
            <Grid item xs={12} sm={4} key={stat.label}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  p: 2,
                  borderRadius: "12px",
                  background: "#f8f9fa",
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "10px",
                    background: stat.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {stat.icon}
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      color: "#adb5bd",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {stat.label}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: "1.1rem",
                      color: "#1a1d23",
                    }}
                  >
                    {stat.value}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Progress bar */}
        <Box sx={{ mt: 2.5 }}>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.8 }}
          >
            <Typography
              sx={{ fontFamily: FONT, fontSize: "0.78rem", color: "#868e96" }}
            >
              Score Progress
            </Typography>
            <Typography
              sx={{
                fontFamily: FONT,
                fontSize: "0.78rem",
                fontWeight: 600,
                color: "#1a1d23",
              }}
            >
              {scorePercent}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={scorePercent}
            sx={{
              height: 8,
              borderRadius: "5px",
              background: "#e9ecef",
              "& .MuiLinearProgress-bar": {
                background: passed ? "#16a34a" : "#e03131",
                borderRadius: "5px",
              },
            }}
          />
        </Box>
      </Paper>

      {/* ── Answers ──────────────────────────────────────────────────── */}
      <Typography
        variant="subtitle1"
        sx={{
          fontFamily: FONT,
          fontWeight: 700,
          color: "#1a1d23",
          fontSize: "1rem",
          mb: 2,
          animation: "fadeUp .45s ease both",
        }}
      >
        Your Answers
      </Typography>

      {results.answers?.map((ans, idx) => {
        const isCorrect = ans.is_correct;
        const userSelected =
          ans.selected_option !== undefined
            ? ans.options[ans.selected_option]
            : "Not answered";
        const correctAnswer = ans.options[ans.correct_option];
        const delay = `${idx * 0.04}s`;

        return (
          <Paper
            key={ans.question_id}
            sx={{
              borderRadius: "16px",
              p: 3,
              mb: 2.5,
              boxShadow: "0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04)",
              background: "#fff",
              border: `1px solid ${isCorrect ? "#bbf7d050" : "#fecaca50"}`,
              animation: `fadeUp .4s ease ${delay} both`,
            }}
          >
            {/* Block header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: isCorrect ? "#16a34a" : "#e03131",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: "0.75rem",
                    }}
                  >
                    {idx + 1}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 700,
                    fontSize: "0.75rem",
                    color: "#868e96",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                  }}
                >
                  Question Block
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    background: "#f8f9fa",
                    borderRadius: "8px",
                    px: 1.5,
                    py: 0.6,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 500,
                      fontSize: "0.75rem",
                      color: "#868e96",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                    }}
                  >
                    Points:
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: "0.85rem",
                      color: isCorrect ? "#16a34a" : "#e03131",
                    }}
                  >
                    {ans.points_earned} / {ans.max_score}
                  </Typography>
                </Box>
                {isCorrect ? (
                  <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
                ) : (
                  <CancelIcon sx={{ color: "#e03131", fontSize: 20 }} />
                )}
              </Box>
            </Box>

            {/* Question text */}
            <Typography
              sx={{
                fontFamily: FONT,
                fontSize: "0.78rem",
                fontWeight: 600,
                color: "#adb5bd",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                mb: 0.8,
              }}
            >
              Question Text
            </Typography>
            <Box
              sx={{
                p: 1.8,
                borderRadius: "10px",
                border: "1px solid #e9ecef",
                background: "#fafbfc",
                mb: 2.5,
              }}
            >
              <Typography
                sx={{
                  fontFamily: FONT,
                  fontSize: "0.95rem",
                  color: "#1a1d23",
                  lineHeight: 1.6,
                }}
              >
                {ans.question_text}
              </Typography>
            </Box>

            {/* Options */}
            <Grid container spacing={1.5}>
              {ans.options.map((opt, optIdx) => {
                const isUserAnswer = optIdx === ans.selected_option;
                const isCorrectOpt = optIdx === ans.correct_option;
                let borderColor = "#e9ecef";
                let bgColor = "#fafbfc";
                let textColor = "#495057";
                if (isCorrectOpt) {
                  borderColor = "#16a34a";
                  bgColor = "#f0fdf4";
                  textColor = "#15803d";
                } else if (isUserAnswer && !isCorrect) {
                  borderColor = "#e03131";
                  bgColor = "#fff5f5";
                  textColor = "#b91c1c";
                }

                return (
                  <Grid item xs={12} sm={6} key={optIdx}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.2,
                        p: 1.4,
                        borderRadius: "10px",
                        border: `1.5px solid ${borderColor}`,
                        background: bgColor,
                      }}
                    >
                      {isCorrectOpt ? (
                        <RadioButtonCheckedIcon
                          sx={{ fontSize: 18, color: "#16a34a", flexShrink: 0 }}
                        />
                      ) : (
                        <RadioButtonUncheckedIcon
                          sx={{
                            fontSize: 18,
                            color: isUserAnswer ? "#e03131" : "#ced4da",
                            flexShrink: 0,
                          }}
                        />
                      )}
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontFamily: FONT,
                            fontSize: "0.7rem",
                            fontWeight: 600,
                            color: isCorrectOpt
                              ? "#16a34a"
                              : isUserAnswer
                              ? "#e03131"
                              : "#adb5bd",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            mb: 0.1,
                          }}
                        >
                          Option {String.fromCharCode(65 + optIdx)}
                          {isCorrectOpt ? " (Correct)" : ""}
                          {isUserAnswer && !isCorrectOpt
                            ? " (Your Answer)"
                            : ""}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: FONT,
                            fontSize: "0.88rem",
                            color: textColor,
                            fontWeight: isCorrectOpt ? 500 : 400,
                          }}
                        >
                          {opt}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Paper>
        );
      })}

      {/* ── Footer CTA ───────────────────────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 4,
          pb: 4,
          animation: "fadeUp .5s ease both",
        }}
      >
        <Button
          variant="contained"
          onClick={() => navigate("/ats/my-assessments")}
          sx={{
            background: TEAL,
            color: "#fff",
            borderRadius: "10px",
            fontFamily: FONT,
            fontWeight: 600,
            fontSize: "0.9rem",
            textTransform: "none",
            px: 3.5,
            py: 1.2,
            boxShadow: "none",
            "&:hover": { background: "#0a7a8a", boxShadow: "none" },
          }}
        >
          Back to My Assessments
        </Button>
      </Box>
    </Box>
  );
};

export default AssessmentResults;
